import _ from 'lodash';
import moment from 'moment';

export function calculateTicks(currentTimestamp, chartSpan, numTicks) {
  const end = moment
    .unix(currentTimestamp)
    .startOf('hour')
    .unix();
  return _.range(numTicks).map(x => end - (x * chartSpan * 3600) / numTicks);
}



// WEBPACK FOOTER //
// /src/components/pages/dashboard/charts.js